// extracted by mini-css-extract-plugin
module.exports = {"root":"TravelGuideTeaser_root__u_4j9","cardBody":"TravelGuideTeaser_cardBody__gEflj","cardTitle":"TravelGuideTeaser_cardTitle__ENGzG"};